'use client';

import { useSession } from 'next-auth/react';
import { useEventSource } from '@/shared/hooks/useEventSource';

/**
 * Маунтится один раз в app layout.
 * Устанавливает SSE-соединение с /api/events/stream.
 * Подключается только когда у пользователя есть familyId (иначе сервер вернёт 401).
 */
export function EventSourceProvider() {
  const { data: session } = useSession();
  const familyId = (session?.user as any)?.familyId;

  useEventSource({ enabled: !!familyId });
  return null;
}
